import React, { useEffect, useRef, useState } from "react";
import HeroSection from "../Components/HeroSection";
import MessageToStudent from "../Components/MessageToStudent";
import LatestUpdates from "../Components/LatestUpdates";
import Courses from "../Components/Courses";
import GalleryCarousel from "../Components/GalleryCarousel";
import Slogan from "../Components/Slogan";
import AictePopup from "../Components/AictePopup";

import axios from "axios";
import { Helmet } from "react-helmet";

function Home() {
  const [notices, setNotices] = useState([]);
  useEffect(() => {
    axios
      .post("/api/notices/getNoticeListClient", {
        pageno: "1",
      }, {
        responseType: 'text'
      })
      .then((res) => {
        let data = res.data;
        try {
          const firstBrace = data.indexOf("{");
          const lastBrace = data.lastIndexOf("}");
          if (firstBrace !== -1 && lastBrace !== -1) {
            data = JSON.parse(data.substring(firstBrace, lastBrace + 1));
          }
        } catch (e) {
          console.log("JSON Parse Error", e);
        }
        setNotices(data.results || []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const scrollRef = useRef(null);
  useEffect(() => {
    if (scrollRef.current && notices && notices.length > 0) {
      const scrollElement = scrollRef.current;
      const scrollWidth = scrollElement.scrollWidth;
      const containerWidth = scrollElement.clientWidth;
      const totalWidth = scrollWidth + containerWidth;

      // Set animation duration based on total width
      const duration = totalWidth / 100; // Adjust this value to control speed
      scrollElement.style.animationDuration = `${duration}s`;
    }
  }, [notices]);

  return (
    <>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <main>
        <AictePopup />
        <HeroSection />

        <section>
          <div className="NoticeScroll" data-aos="fade-down">
            <span className="latestUpdates">
              <h5>Latest Updates :</h5>{" "}
            </span>

            <span
              className="scroll"
              ref={scrollRef}
              style={{ display: "flex" }}
            >
              {notices && notices.map((item) => (
                <span className="noticeItem" key={item.id}>
                  {item.updated_at ? new Date(item.updated_at).toDateString() : ""}&nbsp; - &nbsp;
                  {item.title}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              ))}
            </span>
          </div>
        </section>
        <div className="HomePageContainer">
          <MessageToStudent />
          <LatestUpdates />
          <Courses />
          <GalleryCarousel />
          <Slogan />
        </div>
      </main>
    </>
  );
}

export default Home;
